import { render, staticRenderFns } from "./LoginBridge.vue?vue&type=template&id=0255a0fa&lang=pug&"
import script from "./LoginBridge.vue?vue&type=script&lang=js&"
export * from "./LoginBridge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LoginBridge.vue"
export default component.exports